module.exports = __webpack_public_path__ + "media/src/images/icons/oval-7b57b9d23c39d7fe863f81f0db31a5e9.png";